import { stripSecureFlag } from '@jarvis.oddle/core/tools/cookie'
import { logApiError } from '@jarvis.oddle/core/tools/error'
import { getIP } from '@jarvis.oddle/core/tools/ip'
import logger from '@jarvis.oddle/core/tools/logger'
import { isObjectEmpty } from '@jarvis.oddle/core/tools/object'
import _request from '@jarvis.oddle/core/tools/request'
import { makeQueryString } from '@jarvis.oddle/core/tools/routes'
import {
  API_ROOT as DEFAULT_APP_API_ROOT,
  CUSTOMISATION_BACKEND_BASE_URL,
  origin
} from 'config/server'
import uuid from 'uuid/v4'

export const loadPreviewThemePath = '/theme-preview'
export const loadThemePath = '/theme'
export const getPageDataPath = '/page-data'
export const refreshPreviewIgTokenPath = (targetId) =>
  `/theme-preview/${targetId}/instagram/refresh`
export const refreshIgTokenPath = (targetId) =>
  `/theme/${targetId}/instagram/refresh`

const createDefaultHeaders = (req) => ({
  Cookie: req.get('Cookie'),
  'User-Agent': req.get('User-Agent'),
  Referer: req.get('Referer'),
  'X-Forwarded-For': getIP(req),
  'Content-Type': 'application/json',
  Accept: 'application/json',
  // for new relic
  'X-Request-Id': req.headers['X-Request-Id'] || uuid()
})

const request = async (req, res, options) => {
  logger.verbose(
    `[fesc] ${req.url} requested ${JSON.stringify(options, null, 2)}`
  )
  const response = await _request(options)
  logger.verbose(
    `[fesc] ${req.url} got response ${response.body} ${response.statusCode}`
  )
  logApiError({ req, response, origin, apiRoot: DEFAULT_APP_API_ROOT })
  const cookie = stripSecureFlag(response.headers['set-cookie'])
  if (cookie) res.setHeader('set-cookie', cookie)
  return response
}

const call = async ({ req, res, next, method = 'GET', uri, createHeaders }) => {
  const options = {
    uri,
    method,
    headers:
      typeof createHeaders === 'function'
        ? createHeaders(req)
        : createDefaultHeaders(req)
  }

  // only add body and query to options if exists in the request object
  if (!isObjectEmpty(req.body)) options.body = JSON.stringify(req.body)
  if (!isObjectEmpty(req.query)) options.qs = req.query

  try {
    const response = await request(req, res, options)
    if (response.body) {
      const json = JSON.parse(response.body)
      return res.status(response.statusCode).json(json)
    } else {
      return res.status(response.statusCode).send()
    }
  } catch (error) {
    next(new Error(error))
  }
}

export function createApi(express, apiRoot) {
  const router = new express.Router()

  router.get(loadPreviewThemePath, (req, res, next) =>
    call({
      req,
      res,
      next,
      uri: `${CUSTOMISATION_BACKEND_BASE_URL}${loadPreviewThemePath}${makeQueryString(
        {
          previewToken: req.query.previewToken
        }
      )}`
    })
  )

  router.get(loadThemePath, (req, res, next) =>
    call({
      req,
      res,
      next,
      uri: `${CUSTOMISATION_BACKEND_BASE_URL}${loadThemePath}${makeQueryString({
        siteId: req.query.siteId
      })}`
    })
  )

  router.post(refreshPreviewIgTokenPath(':menuId'), (req, res, next) =>
    call({
      req,
      res,
      next,
      uri: `${CUSTOMISATION_BACKEND_BASE_URL}${refreshPreviewIgTokenPath(
        req.params.menuId
      )}`,
      method: 'POST'
    })
  )

  router.post(refreshIgTokenPath(':menuId'), (req, res, next) =>
    call({
      req,
      res,
      next,
      uri: `${CUSTOMISATION_BACKEND_BASE_URL}${refreshIgTokenPath(
        req.params.menuId
      )}`,
      method: 'POST'
    })
  )

  router.get(getPageDataPath, (req, res, next) =>
    call({
      req,
      res,
      next,
      uri: `${CUSTOMISATION_BACKEND_BASE_URL}${getPageDataPath}${makeQueryString(
        {
          menuId: req.query.menuId,
          siteId: req.query.siteId,
          slug: req.query.slug
        }
      )}`
    })
  )

  return [apiRoot, router]
}
